import { h } from 'preact'

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Post = props => {
  const post = props.post

  const color = post.house_status[0]
    ? post.house_status[0] === 'Te huur'
      ? 'free'
      : post.house_status[0] === 'Binnen 3 maanden vrij'
      ? 'soon'
      : post.house_status[0] === 'Verhuurd'
      ? 'occupied'
      : ''
    : ''
    console.log(post, 'post');

  return (
    <a
      href={post.link}
      className="c-house c-housing__col"
      onMouseEnter={props.handleMouseEnter}
      onMouseLeave={props.handleMouseLeave}
      data-target={post.id}
    >
      <div className="c-house__image-container">
        <div
          className="c-house__image u-image"
          dangerouslySetInnerHTML={{ __html: post.feat_image }}
        />
        <div class={`c-house__status-container u-flex`}>
          <div class={`c-house__status c-house__status--${color}`}>
            {post.house_status[0]}
          </div>
          {post.meta.tag ? (
          <div class={`c-house__tag c-house__tag--${color}`}>
            {post.meta.tag}
          </div>
          ) : null}
        </div>
      </div>

      <div className="c-house__body">
        <div className="c-house__price">Prijs: {post.meta.price}</div>
        <h3 className="c-house__title">{post.title.rendered}</h3>
        <div
          className="c-house__content"
          dangerouslySetInnerHTML={{
            __html: post.content.rendered.replace(/^(.{120}[^\s]*).*/, '$1')
          }}
        />
      </div>

      <div className="c-house__footer">
        {post.meta.capacity ? (
          <div className="c-house__meta">
            <svg className="c-icon c-house__meta-icon">
              <use href="#people" xlinkHref="#people" />
            </svg>
            {post.meta.capacity}
          </div>
        ) : null}
        {post.meta.bedrooms ? (
          <div className="c-house__meta">
            <svg className="c-icon c-house__meta-icon c-house__meta-icon--stroke">
              <use href="#bedroom" xlinkHref="#bedroom" />
            </svg>
            {post.meta.bedrooms}
          </div>
        ) : null}
        {post.meta.bathrooms ? (
          <div className="c-house__meta">
            <svg className="c-icon c-house__meta-icon">
              <use href="#bathroom" xlinkHref="#bathroom" />
            </svg>
            {post.meta.bathrooms}
          </div>
        ) : null}
        {post.meta.surface ? (
          <div className="c-house__meta">
            <svg className="c-icon c-house__meta-icon">
              <use href="#surface" xlinkHref="#surface" />
            </svg>
            {post.meta.surface} m&#178;
          </div>
        ) : null}
      </div>
    </a>
  )
}

export default Post



// WEBPACK FOOTER //
// ./src/js/housing/components/Post.js